import { AppButton, AppSelect } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { Calendar, Check } from 'lucide-react'

type IncentiveFilterSectionProps = {
  selectedPeriod: string
  onPeriodChange: (period: string) => void
  availablePeriods: string[]
  isIncentiveAccepted: boolean
  onOpenConfirmDialog: () => void
}
export function IncentiveFilterSection({
  selectedPeriod,
  onPeriodChange,
  availablePeriods,
  isIncentiveAccepted,
  onOpenConfirmDialog,
}: IncentiveFilterSectionProps) {
  const handleOpenConfirmDialog = () => {
    // 確認済みの場合は何もしない
    if (isIncentiveAccepted) return
    onOpenConfirmDialog()
  }

  return (
    <div className='space-y-4'>
      <div className='flex flex-row justify-between items-center'>
        {/* TODO: セレクトにはラベルを出すべきか、初期値を見て判断でいいのか。マイページの同一要素や検索にはラベルを表示していない */}
        <AppSelect
          leftIcon={<Calendar />}
          label='支払対象期間を選択'
          value={selectedPeriod}
          onValueChange={onPeriodChange}
          options={availablePeriods.map((period) => ({ value: period, label: period }))}
        />

        <AppButton
          onClick={handleOpenConfirmDialog}
          disabled={isIncentiveAccepted}
          variant={isIncentiveAccepted ? 'outline' : 'default'}
        >
          {isIncentiveAccepted && <Check />}
          {isIncentiveAccepted ? 'インセンティブ確認済' : 'インセンティブ確認'}
        </AppButton>
      </div>
    </div>
  )
}
